var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.kindMaster), function(kind) {
    return _c('div', {
      key: kind.kind_id
    }, [_c('v-subheader', {
      domProps: {
        "textContent": _vm._s(kind.kind_name)
      }
    }), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, _vm._l((_vm.productMaster), function(product) {
      return (product.kind_id === kind.kind_id) ? _c('v-flex', {
        key: product.product_id,
        attrs: {
          "xs12": "",
          "sm6": "",
          "md4": "",
          "lg": "",
          "3": "",
          "xl2": ""
        }
      }, [_c('v-checkbox', {
        attrs: {
          "label": product.product_name
        },
        model: {
          value: (product.selected),
          callback: function($$v) {
            product.selected = $$v
          },
          expression: "product.selected"
        }
      })], 1) : _vm._e()
    }))], 1)
  }))
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d001b9f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProductSelect.vue
// module id = Fn/f
// module chunks = 1